import { Pipe, PipeTransform } from '@angular/core';
import { ArrangementResource } from '@thiememeulenhoff/types';
import { ResourceBackgroundImage } from './resource-background-image';

@Pipe({
  name: 'resourceBackgroundImage',
})
export class ResourceBackgroundImagePipe implements PipeTransform {
  transform(
    resource: ArrangementResource | null | undefined,
  ): string | undefined {
    if (!resource) {
      return undefined;
    }

    return ResourceBackgroundImage(resource);
  }
}
